var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"img-background",staticStyle:{"height":"0px","opacity":"0.9","z-index":"-1"},attrs:{"view":"lHh Lpr lFf"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }